module.exports = __webpack_public_path__ + "img/win.d269094e.png";